module.exports = __webpack_public_path__ + "media/images/front/premium_lp/point02/th_04-d4cff1bc6a2b2749ee73cc8cd6c8f234.jpg";